import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import BankingArchive from "../../../Components/Archive/Banking/BankingArchive";
import styles from "./Page_Archive.module.css";
import ArchiveHeader from "./ArchiveHeader";
import BuySellArchive from "../../../Components/Archive/BuySell/BuySellArchive";
import RAArchive from "../../../Components/Archive/RA/RAArchive";
import RFQArchive from "../../../Components/Archive/RFQ/RFQ";

const Page_Archive = () => {
  const role = useSelector(
    (state) => state?.persistedReducer?.user?.activeRole
  );

  const isBanking = role === "BANKING";
  const [type, setType] = useState(isBanking ? "Banking" : "Bilateral");
  const [status, setStatus] = useState("Closed");

  function onBack() {
    window.history.back();
  }

  return (
    <div className={styles.archiveWrapper}>
      <ArchiveHeader
        onBack={onBack}
        initialType={type}
        initialStatus={status}
        onTypeChange={setType}
        onStatusChange={setStatus}
        types={
          isBanking ? ["Banking"] : ["Bilateral", "RFQ", "Reverse Auction"]
        }
      />
      <div
        style={{
          padding: "15px",
        }}
      >
        {role === "BANKING" ? (
          <BankingArchive type={type} status={status} />
        ) : type === "Bilateral" ? (
          <BuySellArchive type={type} status={status} />
        ) : type === "RFQ" ? (
          <RFQArchive type={type} status={status} />
        ) : type === "Reverse Auction" ? (
          <RAArchive type={type} status={status} />
        ) : null}
      </div>
    </div>
  );
};

export default Page_Archive;
